export async function fetchWithTimeout<T>(fn: () => Promise<T>, ms = 5000): Promise<T> {
  return Promise.race([
    fn(),
    new Promise<never>((_, reject) => setTimeout(() => reject(new Error('Subgraph request timed out')), ms)),
  ])
}
